import styles from "./Details.module.css";
import { Input } from "../../../common/Input";
import { Button } from "../../../common/Button";
import { ButtonFooter } from "../../../common/ButtonFooter";
import { useContext } from "react";
import { StatusContext } from "../../../../context/Status";
import axios from "axios";
import { sendMessage } from "../../../../context/utils";
import { RoutingContext } from "../../../../context/Router";
import ZARPayment from "./ZARPayment";

interface DetailsProps {
  accNum?: string;
  accName: string;
  bankName?: string;
  isLoading?: boolean;
  transactionRef: string;
}
export const Details = ({
  accNum,
  accName,
  bankName,
  isLoading,
  transactionRef,
}: DetailsProps) => {
  const { merchantKey, payData } = useContext(RoutingContext);
  const { setPageTransactionStatus } = useContext(StatusContext);
  const { currency } = payData
  
  const onSubmit = async () => {
    if (transactionRef != "") {
      const payload = {
        txnRef: transactionRef,
        // orderId: bTransId,
      };

      try {
        const response = await axios({
          method: "post",
          url: `${process.env.REACT_APP_API_URL}nucleus/wordpressstatus/tnxrefStatus`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-auth-token": merchantKey,
          },
          data: payload,
        });
        const responseData = response.data;

        if (responseData["status"] === "successful") {
          setPageTransactionStatus("success");
          const dataResp = { status: "successful" };
          setTimeout(() => {
            sendMessage(dataResp);
          }, 5000);
        } else if (
          responseData["status"] === "success" &&
          ["Charge initiated", "pending"].includes(responseData["message"])
        ) {
          return;
        } else {
          setPageTransactionStatus("error");
          const dataResp = { status: "ERROR" };
          setTimeout(() => {
            sendMessage(dataResp);
          }, 5000);
        }
      } catch (error) {
        setTimeout(() => {
          sendMessage({ status: "ERROR" });
        }, 5000);
      }
    }
  };

  const onTransferred = () => {
    setPageTransactionStatus("processing");
    onSubmit();
  };

  return (
    <div className={styles.container}>
    {["NGN", "GHS"]?.includes(currency as string) ? (
         <div>
         <form>
            <div className={styles.form}>
              <div className={styles.accNumInput}>
                <Input
                  value={accNum}
                  inputId="accNum"
                  readOnly
                  type="text"
                  label="Account number"
                  // required
                />
                <p className={styles.inputNote}>
                  <span>*</span> Use this account for this transaction only. Account
                  expires in 30 minutes.
                </p>
              </div>
              <div className={styles.dualInput}>
                <Input
                  value={accName}
                  inputId="accName"
                  readOnly
                  type="text"
                  label="Account name"
                />
                <Input
                  value={bankName}
                  inputId="bankName"
                  readOnly
                  type="text"
                  label="Bank name"
                />
              </div>
            </div>
            <ButtonFooter showNote>
              <Button
                type="button"
                text="I have transferred"
                buttonStyle="primary"
                onClick={onTransferred}
                disabled={isLoading}
              />
            </ButtonFooter>
          </form>
         </div>
    ) : (
        <ZARPayment />
    )}
    </div>
  );
};
